module.exports = __webpack_public_path__ + "static/media/clock.daa647df.svg";